module.exports = {
  ID_CARD: 'id-card',
  LICENSE: 'license',
  PROOF_OF_ADDRESS: 'proof-of-address',
  INSURANCE_STATE_OF_INFORMATION: 'insurance-state-of-information',
  PASSPORT: 'passport',
};
